<template>
    <v-dialog v-model="visible" width="800">
        <template #activator="{}">
            <v-row>
                <v-col cols="auto">
                    <v-btn color="primary" @click="open">
                        {{ $t('einstellungen.dialog.button') }}
                    </v-btn>
                </v-col>
                <v-col class="d-flex justify-end" style="padding-right: 100px">
                    <a :href="locale === 'fr' ? 'https://vetdata.ch/fr/pricing' : 'https://vetdata.ch/pricing/'" target="_blank">{{
                        $t('einstellungen.dialog.preislink')
                    }}</a>
                </v-col>
            </v-row>
        </template>
        <form @submit.prevent="submit">
            <v-card>
                <FocusLock>
                    <v-card-title class="headline font-weight-bold mb-2">
                        {{ $t('einstellungen.servicedialog.titel') }}
                    </v-card-title>

                    <v-card-text class="pb-0">
                        <v-row>
                            <v-col sm="5" class="py-0">
                                <h3>{{ $t('einstellungen.servicedialog.subtitel.basis') }}</h3>
                            </v-col>
                            <v-col sm="3" class="py-0 text-center">{{ $t('einstellungen.servicedialog.table.speicherplatz') }}</v-col>
                            <v-col sm="2" class="py-0">{{ $t('einstellungen.servicedialog.table.kosten') }}</v-col>
                            <v-col sm="2" class="py-0">{{ $t('einstellungen.servicedialog.table.kosten') }}</v-col>
                        </v-row>
                        <v-row>
                            <v-col sm="6" class="py-1">
                                {{ $t('einstellungen.servicedialog.table.basis') }}
                            </v-col>
                            <v-col sm="2" class="py-0">{{ $t('einstellungen.servicedialog.table.limit') }}</v-col>
                            <v-col sm="2" class="py-0">{{ $t('einstellungen.servicedialog.table.monatrate') }}</v-col>
                            <v-col sm="2" class="py-0">{{ $t('einstellungen.servicedialog.table.upgrade') }}</v-col>
                        </v-row>
                        <v-row>
                            <v-col sm="6" class="py-1">
                                {{ locale === 'fr' ? userServices.basisService.beschreibungFr : userServices.basisService.beschreibungDe }}
                            </v-col>
                            <v-col sm="2" class="py-1">{{ userServices.basisService.limiteGigaByte }} GB</v-col>
                            <v-col sm="2" class="py-1">{{ userServices.basisService.preisProMonat.toFixed(2) }}</v-col>
                            <v-col sm="2" class="py-1">0.00</v-col>
                        </v-row>
                        <v-row>
                            <v-col sm="12" class="pb-0">
                                <h3>{{ $t('einstellungen.servicedialog.subtitle.speicher') }}</h3>
                            </v-col>
                        </v-row>
                        <v-row v-if="checkNumberOfServices">
                            <v-radio-group v-model="speicher" style="flex: auto">
                                <v-row v-for="(row, index) in services.speicherServices" :key="index">
                                    <v-col sm="6" class="py-1">
                                        <v-radio :value="row.serviceId" :label="locale === 'fr' ? row.beschreibungFr : row.beschreibungDe"></v-radio>
                                    </v-col>
                                    <v-col sm="2" class="py-1 listvalues">{{ row.limiteGigaByte }} GB</v-col>
                                    <v-col sm="2" class="py-1 listvalues">{{ row.preisProMonat.toFixed(2) }}</v-col>
                                    <v-col
                                        v-if="speicher === row.serviceId && speicher === userServices.speicherService?.serviceId"
                                        sm="2"
                                        class="py-1 listvalues"
                                        >0.00</v-col
                                    >
                                    <v-col v-else-if="speicher === row.serviceId" sm="2" class="py-1 listvalues">{{ row.preisProRata.toFixed(2) }}</v-col>
                                    <v-col v-else sm="2" class="py-1 listvalues"></v-col>
                                </v-row>
                            </v-radio-group>
                        </v-row>
                        <v-row v-else>
                            <v-col sm="12" class="py-1 pt-2 pb-0">
                                {{ $t('einstellungen.servicedialog.speicher.empty') }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col sm="8" class="pt-8">
                                <h3>
                                    {{ $t('einstellungen.servicedialog.total') }}
                                    <span v-if="userVerrechnung != null" style="font-size: 0.9em">
                                        {{
                                            $t('einstellungen.servicedialog.totaldatumvon') +
                                            ' ' +
                                            userVerrechnung.verrechnungVon +
                                            $t('einstellungen.servicedialog.totaldatumbis') +
                                            ' ' +
                                            userVerrechnung.verrechnungBis
                                        }})
                                    </span>
                                </h3>
                            </v-col>
                            <v-col sm="2" class="pt-8">{{ totalMonatKosten.toFixed(2) }}</v-col>
                            <v-col sm="2" class="pt-8">{{ totalRataKosten.toFixed(2) }}</v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions class="ml-4">
                        <v-btn color="primary" type="submit" class="modalbutton mb-3">
                            {{ $t('components.dialog.save') }}
                        </v-btn>
                        <v-btn class="modalbutton mb-3" @click="visible = false">
                            {{ $t('components.dialog.cancel') }}
                        </v-btn>
                    </v-card-actions>
                </FocusLock>
            </v-card>
        </form>
    </v-dialog>
</template>

<script lang="ts">
import { ServiceEditApiDto, ServiceVerrechnungApiDto, TeilnehmerServiceApiDto } from '@/api-schema';
import { Component, Prop, Watch, Vue } from 'vue-facing-decorator';

import { namespace } from 'vuex-facing-decorator';

import { NAME as NAME_EINSTELLUNGEN } from '../store';
import { NAME as NAME_HEADER } from '@/store/modules/headerNotification';

const profilModul = namespace(NAME_EINSTELLUNGEN);
const headerModul = namespace(NAME_HEADER);

import { EDIT_SERVICES, GET_ALL_SERVICES } from '../store/actions';
import { NEW_ALERT } from '@/store/modules/headerNotification/actions';

@Component
export default class EditServiceDialog extends Vue {
    @Prop({ required: true, type: Object })
    private userServices!: TeilnehmerServiceApiDto;

    @Prop({ required: false, type: Object, default: null })
    private userVerrechnung!: ServiceVerrechnungApiDto;

    private visible = false;
    private services: ServiceEditApiDto = {};
    private speicher = 0;
    private funktionen: Array<number> = [];
    private totalMonatKosten = 0;
    private totalRataKosten = 0;

    @profilModul.Action(EDIT_SERVICES) edit!: Function;
    @profilModul.Action(GET_ALL_SERVICES) getServices!: Function;

    @headerModul.Action(NEW_ALERT) alertMessage!: Function;

    private onSave() {
        this.edit({
            speicherService: this.speicher,
            funktionServices: this.funktionen,
            rowVersion: this.services.rowVersion
        }).then(() => {
            this.visible = false;
        });
    }

    private open() {
        this.getServices().then((response: any) => {
            this.services = Object.assign({}, response);
            if (this.userServices.speicherService) {
                this.speicher = this.userServices.speicherService.serviceId;
            }
            this.funktionen = [];
            if (this.userServices.funktionService) {
                this.funktionen.push(this.userServices.funktionService.serviceId);
            }
            if (this.services.speicherServices.length > 0) {
                this.visible = true;
            } else {
                this.alertMessage({ text: this.$t('einstellungen.errormessage.speicherupgrade') });
            }
            this.totalMonatKosten = 0;
            this.totalRataKosten = 0;
        });
    }

    submit() {
        this.onSave();
    }

    get checkNumberOfServices(): boolean {
        if (this.services.speicherServices) {
            if (this.services.speicherServices.length > 0) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    @Watch('speicher')
    onSpeicherServiceChanged(newValue: number, oldValue: number) {
        let selectedService;
        let service;

        // Ensure speicherServices exists and is an array
        if (this.services.speicherServices && Array.isArray(this.services.speicherServices)) {
            selectedService = this.services.speicherServices.find((service) => service.serviceId === newValue);
        }

        // Ensure old value is non-zero and speicherServices exists
        if (oldValue !== 0 && this.services.speicherServices) {
            service = this.services.speicherServices.find((service) => service.serviceId === oldValue);
        }

        if (selectedService) {
            if (selectedService.serviceId !== this.userServices.speicherService?.serviceId) {
                this.totalMonatKosten += selectedService.preisProMonat;
                this.totalRataKosten += selectedService.preisProRata;
            }
        }

        if (service) {
            if (service.serviceId !== this.userServices.speicherService?.serviceId) {
                this.totalMonatKosten -= service.preisProMonat;
                this.totalRataKosten -= service.preisProRata;
            }
        }
    }

    @Watch('funktionen')
    onFunktionServicesChanged(newValues: Array<number>, oldValues: Array<number>) {
        oldValues.forEach((value) => {
            if (value !== this.userServices.funktionService.serviceId) {
                const temp = this.services.funktionServices.find((service) => service.serviceId === value);
                this.totalMonatKosten -= temp.preisProMonat;
                this.totalRataKosten -= temp.preisProRata;
            }
        });
        newValues.forEach((value) => {
            if (value !== this.userServices.funktionService.serviceId) {
                const temp = this.services.funktionServices.find((service) => service.serviceId === value);
                this.totalMonatKosten += temp.preisProMonat;
                this.totalRataKosten += temp.preisProRata;
            }
        });
    }
    private get locale(): string {
        return this.$i18n.locale; // Access the current locale from Vue i18n instance
    }
}
</script>
<style scoped>
.listvalues {
    font-family: 'Roboto', sans-serif;
    font-size: 0.875rem;
    color: rgba(0, 0, 0, 0.6);
}
</style>
